import { Checkbox, Tooltip } from '@mui/material'
import { Modal, ModalContent, useDisclosure } from '@nextui-org/react'
import cn from 'classnames'
import React, { useEffect, useState } from 'react'
import LazyLoad from 'react-lazy-load'
import { useTheme } from 'next-themes'
import AssetPreviewDisplay from '../assetpreviewdisplay/AssetPreviewDisplay'
import BackedInfo from '../backedinfo/BackedInfo'
import { MarketCard } from '../card/MarketCard'
import Link2 from '../common/util/input/Link2'
import { MintInfo } from '../mintinfo/MintInfo'
import RankInfo from '../rankinfo/RankInfo'
import { AssetDetailsPopupContent } from './AssetDetailsPopupContent'
import { AssetPreviewInfo } from './AssetPreviewInfo'
import { CollectionAssetName } from './CollectionAssetName'
import MoreOptions from './MoreOptions'
import { useSharedState } from '../waxplorer/Waxplorer'
import { AssetButtons } from '../marketbuttons/AssetButtons'
import { useToast } from '../ui/use-toast'
import { ModalActions } from './ModalActions'
import { showErrorToast, showSuccessToast } from '../../utils/toasts'

// @ts-ignore
const AssetPreview = ({
    asset,
    selectedAsset,
    onAdd,
    bundleView,
    page,
    showOwner,
    selectable,
    searchOwner,
    clickAsset,
    index,
    assetType,
    previewDuration = 2,
    handleCheck,
    selectedAssets = [],
    errorAssets,
    transferredAssets,
    dispatch,
}) => {
    const [newOwner, setNewOwner] = useState(null)
    const { theme } = useTheme()
    const [state] = useSharedState()
    const [action, setAction] = useState(null)

    const userName = state?.activeUser?.accountName
        ? state?.activeUser.accountName
        : null

    const [showMenu, setShowMenu] = useState(false)
    const [burned, setBurned] = useState(false)
    const [canceled, setCanceled] = useState(false)
    const [sold, setSold] = useState(false)
    const [isLoading, setIsLoading] = useState(false)
    const [transferred, setTransferred] = useState(false)

    const { isOpen, onOpen, onClose } = useDisclosure()
    useEffect(() => {
        if (Object.keys(transferredAssets).length > 0) {
            for (let localId of Object.keys(transferredAssets)) {
                if (assetId.toString() === localId.toString()) {
                    setNewOwner(transferredAssets[localId]['newOwner'])
                    asset['owner'] = transferredAssets[localId]['newOwner']
                    asset['newOwner'] = transferredAssets[localId]['newOwner']
                    asset['sender'] = userName

                    if (transferredAssets[localId]['sold']) {
                        setSold(true)
                        setNewOwner(transferredAssets[localId]['owner'])
                        asset['offer'] = transferredAssets[localId]['offer']
                        asset['market'] = transferredAssets[localId]['market']
                    } else if (transferredAssets[localId]['transferred']) {
                        setTransferred(true)
                    } else if (transferredAssets[localId]['transferred']) {
                        setCanceled(true)
                    }
                }
            }
        }
    }, [
        selectedAssets && selectedAssets.length,
        errorAssets && Object.keys(errorAssets).length,
        transferredAssets && Object.keys(transferredAssets).length,
    ])

    const { assetId, collection } = asset

    let {
        name,
        mint,
        rarityScore,
        rank,
        myMint,
        backedTokens,
        symbol,
        mdata,
        template,
    } = asset

    const handleCallBack = (info, action) => {
        if (info) {
            if (info['success']) {
                if (action === 'buy') {
                    setNewOwner(userName)
                    asset['owner'] = newOwner
                    asset['price'] = null
                } else if (action === 'sell') {
                    const soldAssets = info['listings']

                    if (soldAssets) {
                        if (soldAssets) {
                            const transferredItems = {}
                            for (const soldAsset of soldAssets) {
                                const localId = soldAsset['assetId']
                                transferredItems[localId] = soldAsset
                                transferredItems[localId]['listings'] = [
                                    {
                                        market: soldAsset['market'],
                                        listingId: soldAsset['listingId'],
                                        price: soldAsset['price'],
                                        quantity: soldAsset['quantity'],
                                        currency: soldAsset['currency'],
                                        seller: userName,
                                    },
                                ]

                                if (localId.toString() === assetId.toString()) {
                                    asset['listings'] = [soldAsset]
                                }
                            }

                            dispatch({
                                type: 'SET_TRANSFERRED_ASSETS',
                                payload: transferredItems,
                            })
                        }
                        setCanceled(false)
                    }

                    setSold(true)
                } else if (action === 'auction') {
                    const auction = info['auction']

                    asset['auctions'] = [auction]

                    setTransferred(true)
                } else if (action === 'burn_asset') {
                    setBurned(true)
                } else if (action === 'cancel') {
                    setNewOwner(userName)
                    asset['owner'] = userName
                    asset['listings'] = null
                    setCanceled(true)
                    setSold(false)
                } else if (action === 'unstake') {
                    setNewOwner(userName)
                    asset['owner'] = userName
                    setTransferred(true)
                } else if (action === 'selloffer') {
                    setNewOwner('s.rplanet')
                    setSold(true)
                } else if (action === 'transfer') {
                    setNewOwner(info['receiver'])
                    asset['owner'] = info['receiver']
                    asset['sender'] = userName
                } else if (action === 'swap') {
                    asset['contract'] =
                        asset['contract'] === 'simpleassets'
                            ? 'atomicassets'
                            : 'simpleassets'
                }

                if (
                    [
                        'claim',
                        'sell',
                        'transfer',
                        'unpack',
                        'swap',
                        'stake',
                        'unstake',
                        'break_asset',
                    ].includes(action)
                ) {
                    setTransferred(true)
                }
            }
        }
        setAction(null)
        setIsLoading(false)
    }

    const toggleShowMenu = () => {
        setShowMenu(!showMenu)
    }

    const loadBack = (e) => {
        onOpen()
        if (e) e.preventDefault()
    }

    const assetIncluded = () => {
        return selectedAssets
            .map(
                (a) =>
                    Object.assign(
                        {},
                        a,
                        a.assets?.length > 0 ? a.assets[0] : null,
                    ).assetId,
            )
            .includes(
                Object.assign(
                    {},
                    asset,
                    asset.assets?.length > 0 ? asset.assets[0] : null,
                ).assetId,
            )
    }

    const checked = assetIncluded()

    const handleClose = () => {
        onClose()
    }

    const cardHeader = (
        <div className={'absolute w-full h-8 z-10'}>
            <div className={'absolute flex m-auto h-10 w-8'}>
                {selectable && selectable(asset) && (
                    <Checkbox
                        checked={checked}
                        onChange={(e) => handleCheck(e, asset)}
                    />
                )}
            </div>
            <div />
            <div />
            {page !== 'newbuyoffer' && page !== 'editor' && (
                <MoreOptions
                    setShowMenu={setShowMenu}
                    newOwner={newOwner}
                    showMenu={showMenu}
                    asset={asset}
                    handleCallBack={handleCallBack}
                    burned={burned}
                    sold={sold}
                    setSold={setSold}
                    setIsLoading={setIsLoading}
                    transferred={transferred}
                    toggleShowMenu={toggleShowMenu}
                    setAction={setAction}
                />
            )}
        </div>
    )

    const href = symbol
        ? '/pack/' + symbol + (assetId ? `?asset_id=${assetId}` : '')
        : assetId
        ? '/asset/' + assetId
        : template?.templateId
        ? '/template/' + template?.templateId
        : ''

    const { toast } = useToast()

    const callBack = (info, localAction = null) => {
        if (info?.success) {
            if (info?.transactionId) {
                showSuccessToast(
                    toast,
                    <Link2
                        external={true}
                        href={
                            'https://waxblock.io/transaction/' +
                            info.transactionId
                        }
                    >
                        <div className={'text-xs font-medium'}>
                            {info.transactionId.substr(0, 32) + '...'}
                        </div>
                    </Link2>,
                )
            }
        }
        if (info?.error) {
            showErrorToast(toast, info.error)
        }

        handleCallBack(info, localAction ? localAction : action)

        setAction(null)
    }

    const assetButtons = (view) => (
        <AssetButtons
            view={view}
            className={
                view === 'full'
                    ? 'mt-auto h-full w-full'
                    : 'mt-auto h-32 w-full'
            }
            onAdd={onAdd}
            asset={asset}
            loadBack={loadBack}
            newOwner={newOwner}
            searchOwner={searchOwner}
            burned={burned}
            transferred={transferred}
            assetType={assetType}
            page={page}
            canceled={canceled}
            sold={sold}
            setSold={setSold}
            callBack={callBack}
            setIsLoading={setIsLoading}
            isLoading={isLoading}
            showOwner={showOwner}
            onOpen={onOpen}
            onClose={onClose}
            isOpen={isOpen}
            setAction={setAction}
        />
    )

    return (
        <LazyLoad offset={200}>
            <>
                <MarketCard
                    height={'normal'}
                    cardHeader={cardHeader}
                    page={page}
                    new={asset['new']}
                >
                    <ModalActions
                        action={action}
                        asset={asset}
                        callBack={callBack}
                    />
                    <div
                        className={
                            ' relative flex  justify-center items-center  !aspect-1'
                        }
                    >
                        <div
                            className={cn(
                                'flex justify-center items-center w-full h-full',
                            )}
                        >
                            <Link2
                                inactive={
                                    page === 'newbuyoffer' ||
                                    page === 'editor' ||
                                    clickAsset
                                }
                                href={href}
                                onClick={(e) => {
                                    const elem = window.document.getElementById(
                                        'AssetDetailsPopupContent' +
                                            (assetId ? assetId : templateId),
                                    )
                                    if (!elem || !elem.contains(e.target)) {
                                        dispatch({
                                            type: 'SET_ACTION_SEARCH',
                                            payload: {
                                                actionSearch: '',
                                                asset: null,
                                                searchType: '',
                                                searchID: '',
                                                includeDrops: false,
                                            },
                                        })
                                    }
                                }}
                                altOnClick={
                                    clickAsset
                                        ? () => clickAsset(index)
                                        : () => {}
                                }
                                className={cn('h-full w-full')}
                            >
                                <div
                                    className={cn(
                                        'relative m-auto cursor-pointer h-full w-full',
                                    )}
                                >
                                    <Tooltip
                                        leaveDelay={100}
                                        title={
                                            <AssetDetailsPopupContent
                                                asset={asset}
                                                userName={userName}
                                            />
                                        }
                                        placement="right"
                                        arrow
                                        enterDelay={700}
                                        enterNextDelay={700}
                                        disableTouchListener
                                        componentsProps={{
                                            tooltip: {
                                                sx: {
                                                    borderRadius: '1rem',
                                                    backgroundColor:
                                                        theme === 'light'
                                                            ? 'white'
                                                            : '#141414FA',
                                                    maxWidth: 'none',
                                                },
                                            },
                                        }}
                                    >
                                        <div className="relative flex w-full h-full overflow-hidden">
                                            <AssetPreviewDisplay
                                                asset={asset}
                                                previewDuration={
                                                    previewDuration
                                                }
                                                className={cn('h-full')}
                                                imgClassName={cn(
                                                    'object-contain transition transform max-h-full max-w-full',
                                                    'duration-500 md:hover:scale-100 hover:scale-105 cursor-pointer',
                                                )}
                                                mdata={mdata}
                                            />
                                        </div>
                                    </Tooltip>
                                </div>
                            </Link2>
                        </div>
                        {mint && !rank && !rarityScore ? (
                            <MintInfo
                                top={'-bottom-4 right-1'}
                                mint={mint}
                                myMint={myMint}
                            />
                        ) : (
                            ''
                        )}
                        {rank && rarityScore ? (
                            <RankInfo rank={rank} rarityScore={rarityScore} />
                        ) : (
                            ''
                        )}
                        {backedTokens && (
                            <BackedInfo backedTokens={backedTokens} />
                        )}
                    </div>
                    <div
                        className={
                            'p-4 flex space-y-2 flex-wrap h-full justify-between'
                        }
                    >
                        <CollectionAssetName
                            linkInactive={
                                page === 'newbuyoffer' ||
                                page === 'editor' ||
                                clickAsset
                            }
                            collection={collection}
                            onClick={() => {
                                dispatch({
                                    type: 'SET_ACTION_SEARCH',
                                    payload: {
                                        actionSearch: '',
                                        asset: null,
                                        searchType: '',
                                        searchID: '',
                                        includeDrops: false,
                                    },
                                })
                            }}
                            altOnClick={
                                clickAsset ? () => clickAsset(index) : () => {}
                            }
                            href={href}
                            name={name ? name : assetId}
                        />
                        {!selectedAsset &&
                            selectedAsset !== 0 &&
                            assetButtons('')}
                    </div>
                </MarketCard>
                <Modal
                    isOpen={isOpen}
                    onClose={handleClose}
                    size="4xl"
                    scrollBehavior={'inside'}
                    classNames={{
                        body: 'p-0',
                        closeButton:
                            'absolute top-2 right-1 p-2 z-50 bg-red-500 text-white hover:bg-red-600',
                    }}
                    placement="top"
                >
                    <ModalContent>
                        {(onClose) => (
                            <>
                                <AssetPreviewInfo
                                    cancel={handleClose}
                                    asset={asset}
                                    newOwner={newOwner}
                                    bundleView={bundleView}
                                    buttons={assetButtons('full')}
                                />
                            </>
                        )}
                    </ModalContent>
                </Modal>
            </>
        </LazyLoad>
    )
}

function assetPropsAreEqual(prevAsset, nextAsset) {
    let item1 = 0
    let item2 = 0

    const id1 = (
        prevAsset.asset.assets?.length > 0
            ? prevAsset.asset.assets[0]
            : prevAsset.asset
    ).assetId

    if (
        prevAsset.selectedAssets &&
        prevAsset.selectedAssets
            .map((a) => (a.assets?.length > 0 ? a.assets[0] : a).assetId)
            .includes(id1)
    ) {
        item1 = id1
    }

    const id2 = (
        nextAsset.asset.assets?.length > 0
            ? nextAsset.asset.assets[0]
            : nextAsset.asset
    ).assetId

    if (
        nextAsset.selectedAssets &&
        nextAsset.selectedAssets
            .map((a) => (a.assets?.length > 0 ? a.assets[0] : a).assetId)
            .includes(id2)
    ) {
        item2 = id2
    }

    return (
        ((!prevAsset.selectedAssets && !nextAsset.selectedAssets) ||
            (prevAsset.selectedAssets &&
                nextAsset.selectedAssets &&
                prevAsset.selectedAssets.length ===
                    nextAsset.selectedAssets.length)) &&
        id1 === id2 &&
        prevAsset.index === nextAsset.index &&
        item1 === item2 &&
        prevAsset.isSelected === nextAsset.isSelected &&
        item1 === 0 &&
        item2 === 0
    )
}

export default React.memo(AssetPreview, assetPropsAreEqual)
